import React, {PropTypes} from 'react';
import {Modal} from 'reactstrap';
import {I18n} from 'react-redux-i18n';

const LabelAddedModal = ({
  isOpen,
  onClose
}) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} id="modalSelectStore">
      {/* <div className="modal-header">
        <h4 className="modal-title" id="exampleModalLabel">{I18n.t('LABEL_ADDED')}</h4>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
          <span className="lnr lnr-cross" aria-hidden="true"/>
        </button>
      </div> */}
      <div className="modal-body">
        <div className="row">
          <div className="col-sm-12">
            {I18n.t('LABEL_ADDED_MESSAGE')}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-primary" onClick={onClose}>{I18n.t('CONTINUE')}</button>
      </div>
    </Modal>
  );
};

LabelAddedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LabelAddedModal;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelAddedModal.js
 **/